import { Box, Typography } from "@mui/material";
import SavedAddress from "components/saved-address";
import { useNavigate } from "react-router-dom";

const SavedAddressPage = () => {
  const navigate = useNavigate();
  return (
    <Box>
      <Box
        sx={{
          display: {
            md: "flex",
            lg: "flex",
            xl: "flex",
            sm: "flex",
            xs: "flex",
          },
          px: "4%",
          py: "20px",
          borderBottom: "1px solid #F4F4F4",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            flex: 2,
          }}
        >
          <img
            src="/assets/img/icons/arrow_left.svg"
            alt=""
            width="24px"
            height="24px"
            onClick={() => navigate(-1)}
          />
          <Typography
            sx={{
              color: "#323232",
              fontWeight: 600,
              fontSize: "24px",
              lineHeight: "35px",
            }}
          >
            Saved Address
          </Typography>
        </Box>
      </Box>
      <SavedAddress />
    </Box>
  );
};

export default SavedAddressPage;
